import { apiClient } from "@/lib/apiClient";
import type { PackageForSale, SaleResult } from "@/lib/appointment/abonements";

/** Packages on sale, those covering the appointment's services first (boona types-for-sale). */
export async function fetchPackagesForSale(serviceIds: number[]): Promise<PackageForSale[]> {
  const { data } = await apiClient.get("/api/v1/company/abonements/types-for-sale", {
    params: { service_ids: serviceIds.join(",") },
  });
  return Array.isArray(data?.data) ? data.data : [];
}

/** Sell a package to the appointment's client now (boona POST /company/abonements/sell). */
export async function sellPackage(body: {
  record_id: number;
  type_id: number;
  account_id: number | null;
  amount: string;
  service_ids: number[];
}): Promise<SaleResult> {
  const { data } = await apiClient.post("/api/v1/company/abonements/sell", body);
  return data;
}
